import { render, staticRenderFns } from "./BetDetailModal.vue?vue&type=template&id=52d4c992"
import script from "./BetDetailModal.vue?vue&type=script&lang=ts"
export * from "./BetDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports